export { default as Picture } from './Picture';
